<template>
  <div id="identify">
    <div class="block block-right">
      <div class="item">
        <label for="nickname">昵称</label>
        <input id="nickname" type="text" v-model="info.nickname" readonly/>
      </div>
      <div class="item">
        <label>性别</label>
        <div class="gender">
          <span>
            <input type="radio" v-model="info.gender" value="2">
            <img src="@/assets/images/common/sex-female.png" alt="">
          </span>
          <span>
            <input type="radio" v-model="info.gender" value="1">
            <img src="@/assets/images/common/sex-male.png" alt="">
          </span>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="item">
        <label for="realname">真实姓名</label>
        <input id="realname" type="text" v-model="info.real_name" placeholder="请输入真实姓名"/>
      </div>
      <!-- <div class="item">
        <label for="wxnumber">微信号</label>
        <input id="wxnumber" type="text" v-model="info.wx_number" placeholder="请输入微信号"/>
      </div> -->
      <div class="item">
        <label for="tel">手机号</label>
        <input id="tel" type="number" v-model="info.telephone" placeholder="请输入手机号"/>
      </div>
      <div class="item">
        <label for="code">验证码</label>
        <input id="code" type="text" v-model="code" placeholder="请输入验证码"/>
        <button @click="getCode" :disabled="btnDisabled">{{getCodeBtn}}</button>
      </div>
    </div>
    <div class="save">
      <button @click="checkInfo">保存</button>
    </div>
  </div>
</template>

<script>
// 认证
export default {
  name: 'identify',
  data(){
    return {
      getCodeBtn: '获取验证码',
      btnDisabled: false,
      code:'',
      info:{
        nickname:'',
        gender:'',
        real_name:'',
        telephone:'',
        // wx_number:''
      }
    }
  },
  methods: {
    // 验证手机号
    verifyTel(){
      return /^1\d{10}$/.test(this.info.telephone)
    },
    // 验证码倒数
    countdown(){
      let timer = null,
        s = 120
      clearInterval(timer);
      this.btnDisabled = true
      // this.getCode()
      if (!this.btnDisabled) return;
      timer = setInterval( () => {
        s--
        if (s >= 0) {
          this.getCodeBtn = `剩余${s}秒`
        } else {
          this.getCodeBtn = '重新发送'
          this.btnDisabled = false
          clearInterval(timer)
          s = 120
        }
      }, 1000)
    },
    // 获取验证码
    getCode(){
      if( this.verifyTel() ){
        this.axios({
          method: 'POST',
          url: '/sms/send',
          headers: {
            'Authorization': `Bearer ${this.Global.getCookie('token')}` 
          },
          data:{
            telephone: this.info.telephone
          }
        }).then((res) => {
          if(res.data.code == 0){
            this.$toast('验证码已发送')
            this.countdown()
          }else if(res.data.code == 50002){
            this.$toast('验证码发送频繁，请稍后再试')
          }
        })
      }else {
        this.$toast('请输入正确的手机号')
      }
    },
    // 验证
    verifyCode(){
      this.axios({
        method: 'POST',
        url: '/sms/verify',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data:{
          telephone: this.info.telephone,
          code: this.code
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.editInfo()
        }else if(res.data.code == 40003){
          this.$toast(res.data.message)
        }else{
          this.$toast(res.data.message)
        }
      })
    },
    // 检查填写的信息
    checkInfo(){
      if(this.info.gender == ''){
        this.$toast('请选择您的性别')
      } else if(this.info.real_name == ''){
        this.$toast('请填写您的真实姓名')
      } 
      // else if(this.info.wx_number == ''){
      //   this.$toast('请填写您的微信号')
      // }
       else if(this.info.telephone == ''){
        this.$toast('请填写手机号')
      } else if( !this.verifyTel() ){
        this.$toast('请输入正确的手机号')
      } else if( !/^\d{6}$/.test(this.code) ){
        this.$toast('验证码必须为6位数字')
      } else {
        this.verifyCode()
      }  
    },
    // 编辑信息
    editInfo(){
      this.axios({
        method: 'PATCH',
        url: '/user/profile',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data:{
          gender: this.info.gender,
          real_name: this.info.real_name,
          telephone: this.info.telephone,
          // wx_number: this.info.wx_number
        }
      }).then((res) => {
        if(res.data.code == 0){
          // this.Storage.session.set('denglu', false)
          this.$toast('修改成功')
          this.$router.push('/personal')
        }else{
          this.$toast(res.data.message)
        }
      })
    },
    // 获取原有信息
    getBaseInfo(){
      this.axios({
        method: 'GET',
        url: '/user',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          let data = res.data.data
          this.info.nickname = data.nickname
          this.info.gender = data.gender
          this.info.telephone = data.telephone
          this.info.real_name = data.real_name
          // this.info.wx_number = data.wx_number
        }
      }).catch(e=>{
        this.$throw(e)
      })
    }
  },
  created(){
    this.getBaseInfo()
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
  input::-webkit-input-placeholder { 
    color: #7F7F7F; 
  }
  #identify{
    background: #F6F3F7;
    min-height: 100vh;
  }
  .block{
    margin-top: 1.5rem;
    background: #FFF;
    padding: 0 1.125rem;
  }
  .block .item{
    display: flex;
    align-items: center;
    height: 2.875rem;
    border-bottom: 1px solid #d7dae2;
    justify-content: space-between;
    color: #403F3F;
  }
  .block .item:last-child{
    border: none;
  }
  .block .item label{
    font-size: 0.875rem;
    font-weight: 400;
    width: 5.3125rem;
    margin-left: 0.4375rem;
  }
  .block .item > input{
    font-size: 0.875rem;
    font-weight: 400;
    border: none;
    flex: 1;
  }
  .block .item .gender{
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center
  }
  .block .item .gender span{
    display: flex;
    align-items: center;
    margin-left: 1.63rem;
  }
  .block .item .gender span input[type='radio']{
    -webkit-appearance: none;
    width: 0.8125rem;
    height: 0.8125rem;
    border-radius: 50%;
    outline: none;
    border: 0.0625rem solid;
    position: relative;
  }
  .block .item .gender span:first-of-type input[type='radio']{
    color: #FE5C9E;
  }
  .block .item .gender span:last-of-type input[type='radio']{
    color: #09BBFC;
  }

  .block .item .gender span input[type='radio']:checked::before{
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .block .item .gender span:first-of-type input[type='radio']:checked::before{
    background: #FE5C9E;
  }
  .block .item .gender span:last-of-type input[type='radio']:checked::before{
    background: #09BBFC;
  }

  
  .block .item .gender img{
    width: 1.3125rem;
    margin-left: 0.625rem;
  }
  #code{
    width: 4rem;
  }
  #code + button{
    width: 5.9375rem;
    height: 1.875rem;
    line-height: 1.75rem;
    border: 1px solid;
    border-radius: 0.9375rem;
    background: #FFF;
    font-size: 0.875rem;
    color: #FF9024;
    margin-left: 1rem;
  }
  #code + button:disabled{
    color: #7F7F7F;
  }
  .block-right .item input{
    text-align: right;
  }
  .save{
    text-align: center;
    margin-top: 6.5rem;
  }
  .save button{
    width: 21.875rem;
    height: 2.8125rem;
    line-height: 2.8125rem;
    color: #FFF;
    font-size: 1.25rem;
    font-weight: 500;
    border-radius: 1.4375rem;
    box-shadow: 0.0625rem 0.3125rem 0.5625rem 0 rgba(245,130,18,0.27);
  }
</style>